module.exports = __webpack_public_path__ + "img/remove_pedestrians.bc51f7eb.png";